module.exports = __webpack_public_path__ + "img/calendar.e613ae06.svg";